import { IsoWeekDay } from "../enumerations"
import * as moment from "moment";

declare module "moment" {
    interface Moment
    {
        /**
         * Gibt den ersten Tag einer Woche zurück. Nicht das Datum.
         * @param startOfWeek
         */
        getStartOfWeek: (startOfWeek: number) => moment.Moment,

        /**
         * Gibt den letzten Tag einer Woche zurück. Nicht das Datum.
         * @param startOfWeek
         */
        getEndOfWeek: (endOfWeek: number) => moment.Moment,


        isoMonth: () => number
    }
}

moment.fn.getStartOfWeek = function (startOfWeek: IsoWeekDay): moment.Moment
{
    var diff: number = this.isoWeekday() - startOfWeek;
    return moment(this).add(-diff, "days");
};

moment.fn.getEndOfWeek = function (endOfWeek: IsoWeekDay): moment.Moment
{
    var diff: number = endOfWeek - this.isoWeekday();
    return moment(this).add(diff, "days");
};

moment.fn.isoMonth = function (): number
{
    return this.month() + 1;
};